import rybbit from "@rybbit/js"
import { env } from "configs/EnvironmentConfig"
import posthog from "posthog-js"
import { PropsWithChildren, useEffect } from "react"

/**
 *  A special component that wraps the application and adds analytics capabilities.
 */
export function TrackingWrapper({ children }: PropsWithChildren) {
  useEffect(() => {
    const rybbitSiteId = env.RYBBIT_SITE_ID

    // if we have a rybbit site id, initialize the rybbit library
    if (rybbitSiteId) {
      void rybbit.init({
        siteId: rybbitSiteId,
        analyticsHost: "https://app.rybbit.io/api",

        // NOTE: rybbit autocapture has to be disabled in the dashboard.
      })
    }

    const posthogKey = env.POSTHOG_KEY

    // if we have a posthog key, initialize posthog lib
    if (posthogKey) {
      posthog.init(posthogKey, {
        api_host: "https://eu.i.posthog.com",
        defaults: "2025-05-24",
        autocapture: false,
      })
    }
  }, [])

  // just pass through the children
  return children
}
